var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "html-block"
  }, [_c('h3', {
    staticClass: "html-block__title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "html-block__content",
    class: {
      'html-block__content--unstyled': _vm.listUnstyled
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }